// IntersectionObserver

const iSObservers = document.querySelectorAll('.js-trigger');

const obsOptions = {

  root: null,

  rootMargin: '-10%',

  threshold: 0.1,

};

const fadeIn = (target) => {

  target.classList.add('is-active');

};

const observeUse = (entries) => {

  entries.forEach(entry => {

    if (entry.isIntersecting) {

      fadeIn(entry.target);

    }

  });

};

const observer = new IntersectionObserver(observeUse, obsOptions);

iSObservers.forEach(iSObserver => {

  observer.observe(iSObserver);

});